export default "__VITE_ASSET__D9yjnY_z__"